import React, { useRef } from "react";
import { _getBaseUrl } from "../utils/helper";

const KeywordSearch = ({
  placeholder,
  searchValue,
  setSearchValue,
  onChange,
  onFocus,
  onBlur,
  onKeyUp,
  ...props
}) => {
  const inputRef = useRef(null); // Create a reference for the input field

  const handleInputChange = (event) => {
    const value = event.target.value;
    setSearchValue(value);
    onChange && onChange(event);
  };

  return (
    <fieldset 
      className={`w-full relative ${props.class ?? ""}`}
      tabIndex="-1"
      onClick={(e) => {
        // Only focus input if not clicking the input itself or the clear button
        if (e.target !== inputRef.current && e.target.tagName !== 'BUTTON') {
          inputRef.current?.focus();
        }
      }}
    >
      <legend className="sr-only">Zoeken</legend>
      <img
        src={`${_getBaseUrl("src/assets/icons/search-icon.svg", true)}`}
        alt="Search Icon"
        className="w-5 h-5 z-10 absolute left-6 top-1/2 -translate-y-1/2"
      />

      <input
        ref={inputRef} // Attach ref to input
        type="search"
        className="search placeholder-black placeholder:text-base placeholder:font-roboto block w-full py-4 pl-16 pr-8 text-base input-keyword bg-transparent outline-none border border-gewDarkGrey bg-white focus-within:ring-rounded focus-within:ring-2 focus-within:ring-[#275ec5]"
        placeholder={placeholder}
        value={searchValue}
        onChange={handleInputChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            onKeyUp && onKeyUp(e); // call existing handler if passed
            setSearchValue("");    // clear the input
          } else {
            onKeyUp && onKeyUp(e);
          }
        }}
        aria-label="Zoek"
      />
      {searchValue && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            setSearchValue("");
          }}
          tabIndex="-1"
          className="absolute right-3 top-1/2 -translate-y-1/2 z-10"
          aria-label="Zoeken wissen"
        >
        </button>
      )}


    </fieldset>
  );
};

export default KeywordSearch;
